import { environment } from '../../../../environments/environment';

export function AccountSubdomainAvailableValidatorDirective($q, $http) {
  return {
    require: 'ngModel',
    link: function (scope, element, attrs, ngModel) {
      ngModel.$asyncValidators.accountSubdomainAvailable = function (modelValue) {
        if (modelValue !== attrs.accountSubdomainAvailableValidator) {
          return $http.get(
            environment.apiEndpoint + 'sessions/check_account_subdomain?q=' + modelValue
          );
        }

        return $q.resolve(true);
      };
    },
  };
}

AccountSubdomainAvailableValidatorDirective.$inject = ['$q', '$http'];
